import { apiClient } from './authService';

// Les PERSONNES de l'équipe (≠ les comptes) : reconnaissance au moment d'agir
// (code tapé au clavier) et gestion par le compte propriétaire.
// Le serveur dit QUI c'est et rend une preuve (`token`) — voir identityGate.js.
const fail = (error, fallback) => {
  const res = error.response;
  const data = res && res.data;
  let detail = data && (data.detail || data.pin || data.name || data.level || data.store);
  if (Array.isArray(detail)) detail = detail.join(' ');
  const failure = new Error(detail || fallback);
  failure.status = res ? res.status : 0;
  failure.detail = failure.message;
  failure.locked = !!(data && data.locked);
  failure.pin = data && data.pin; // erreur sur le code (ex. un chef d'équipe a besoin de 2 caractères)
  return failure;
};

const sellerIdentityService = {
  // { required, pin } — tant que personne n'a de code, required = false et
  // rien n'est demandé.
  getStatus: async () => {
    const response = await apiClient.get('auth/identify/');
    return response.data;
  },

  // -> { id, name, level, method, token } ; rejette { status, detail, locked }.
  // minLevel ('manager' | 'owner') : action réservée, 403 si la personne reconnue
  // n'a pas le niveau.
  identify: async (payload, minLevel) => {
    try {
      const response = await apiClient.post('auth/identify/', minLevel ? { ...payload, min_level: minLevel } : payload);
      return response.data;
    } catch (error) {
      throw fail(error, 'Serveur injoignable. Réessayez.');
    }
  },

  identifyByPin: (pin, minLevel) => sellerIdentityService.identify({ pin }, minLevel),

  // ---- Gestion (compte propriétaire) ----
  listPeople: async () => (await apiClient.get('auth/people/')).data,

  savePerson: async (person) => {
    try {
      const response = person.id
        ? await apiClient.patch(`auth/people/${person.id}/`, person)
        : await apiClient.post('auth/people/', person);
      return response.data;
    } catch (error) {
      throw fail(error, "Impossible d'enregistrer la personne.");
    }
  },

  deletePerson: async (id) => { await apiClient.delete(`auth/people/${id}/`); },

  // Journal « qui a fait quoi » (comptes propriétaire / manager).
  listActions: async (params) => (await apiClient.get('auth/actions/', { params })).data,
};

export default sellerIdentityService;
